import React from "react";
import { Alert, Table } from "antd";
import { DatePickerItem, dineroDisabledMask, ModalItem } from "../../../../Components/Items";

const columnas = (onChangeFecha) => [
  { title: "Dia", dataIndex: "nombreDia", key: "nombreDia" },
  {
    title: "Fecha de entrega",
    key: "fecha",
    width: 180,
    render: (_, registro) => (
      <DatePickerItem
        value={registro.fecha}
        placeholder={registro.fecha ? "Fecha" : "Sin fecha definida"}
        allowClear={registro.dia === "mensual"}
        onChange={(fecha) => onChangeFecha(registro.dia, fecha)}
      />
    ),
  },
  {
    title: "Partidas",
    key: "partidas",
    width: 90,
    align: "right",
    render: (_, registro) => registro.lineas.length,
  },
  {
    title: "Total",
    key: "total",
    width: 130,
    align: "right",
    render: (_, registro) => dineroDisabledMask(registro.totales.total),
  },
];

// Ultimo paso antes de crear los pedidos: revisar/ajustar la fecha de cada uno
const ModalConfirmarPedidosImss = ({ visible, dias, onChangeFecha, onCancel, onConfirmar }) => {
  const faltaFecha = dias.some((dia) => dia.dia !== "mensual" && !dia.fecha);

  return (
    <ModalItem
      title={`Confirmar ${dias.length} pedido(s) a crear`}
      visible={visible}
      onCancel={onCancel}
      footer
      onOk={onConfirmar}
      okText="Confirmar y crear pedidos"
      cancelText="Cancelar"
      width={760}
    >
      <p style={{ margin: "10px 0" }}>
        Ultima revision antes de crear los pedidos. Ajusta la fecha de entrega si algo no cuadra.
      </p>
      <Table size="small" rowKey="key" dataSource={dias} columns={columnas(onChangeFecha)} pagination={false} />
      {faltaFecha && (
        <Alert
          type="warning"
          showIcon
          style={{ marginTop: 10 }}
          message="Falta la fecha de entrega de alguno de los pedidos"
        />
      )}
    </ModalItem>
  );
};

export default ModalConfirmarPedidosImss;
